// @flow
import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router'
import colors from '../../styles/colors'
import media from '../../styles/media'

const Nav = styled.nav`
  background: #fff;
  border-bottom: 1px solid #e1e6eb;
`

const TabContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: 100px;

  ${media.mdUp} {
    height: 50px;
  }
`

const Tab = styled(Link)`
  display: flex;
  align-items: center;
  padding: 0 1rem;

  &:hover, &:focus {
    text-decoration: none;
  }

  &.active {
    color: ${colors.primary}
    box-shadow: inset 0 -2px ${colors.primary};
  }
`

const Dashboard = ({ children }: { children?: any }) => (
  <div>
    <Nav>
      <div className="container">
        <TabContainer>
          <Tab to="/settings" activeClassName="active">
            <span className="fa fa-cog" style={{ marginRight: '6px' }} />
            <span>Settings</span>
          </Tab>
          <Tab to="/favorites" activeClassName="active">
            <span className="fa fa-heart" style={{ marginRight: '6px' }} />
            <span>Favorites</span>
          </Tab>
          <Tab to="/searches" activeClassName="active">
            <span className="fa fa-search" style={{ marginRight: '6px' }} />
            <span>Searches</span>
          </Tab>
          <Tab to="/scheduled-tours" activeClassName="active">
            <span className="fa fa-calendar" style={{ marginRight: '6px' }} />
            <span>Tours</span>
          </Tab>
          <Tab to="/offers" activeClassName="active">
            <span className="fa fa-file" style={{ marginRight: '6px' }} />
            <span>Offers</span>
          </Tab>
        </TabContainer>
      </div>
    </Nav>
    <div className="container">
      <div style={{ padding: '3rem 0' }}>{children}</div>
    </div>
  </div>
)

export default Dashboard



// WEBPACK FOOTER //
// ./src/containers/Dashboard/index.js